import { useNavigate } from 'react-router-dom';
import { FaRegCircleXmark } from 'react-icons/fa6';
import VideoCardV2 from '../../../component/VideoCardV2';
import { generatePlayerPageViewUrl } from '../../../utils/generatePlayerPageViewUrl';
import useRecommendedVideos from '../hooks/useRecommendedVideos';
import { Col, Row } from 'react-bootstrap';
import { SHOPIFY_PRODUCT_LINK } from '../../../constants/SocialMediaLinks';
import { useVideoDetailsFromParams } from '../hooks/useVideoDetailsFromParams';
import TRC_CONTENT from '@/constants/trcContentType';

const ViewMoreModal = ({ selectedVideo, videos = [], setIsSideBarOpen, products = [], contentType = "" }) => {
  const navigate = useNavigate();
  const { typeOfContentView, playlistId } = useVideoDetailsFromParams();

  const isTrc = contentType === TRC_CONTENT.TRC;
  const { recommendedText } = useRecommendedVideos({ isVideoRequired: false , skip: isTrc});

  const displayText = isTrc
    ? "Equipment"
    : products.length > 0
    ? "ALL PRODUCTS"
    : recommendedText || "Recommended Videos";

  const redirectToVideo = (videoId) => {
    setIsSideBarOpen(false);
    const url = generatePlayerPageViewUrl(videoId, typeOfContentView, playlistId);
    navigate(url);
  };

  const redirectToProduct = (product) => {
    const url = `${SHOPIFY_PRODUCT_LINK}/${product?.handle}${product?.variantId ? `?variant=${product.variantId}` : ''}`;
    window.open(url, "_blank");
  };

  return (
    <div className="sidebar-overlay">
      <div className="sidebar-container">
        <div className="sidebar-heading">
          <h3>{displayText}</h3>
          <a className="cross-btn">
            <FaRegCircleXmark color="white" onClick={() => setIsSideBarOpen(false)} />
          </a>
        </div>

        {selectedVideo && (
          <div
            className="sidebar-main-video"
            onClick={() => redirectToVideo(selectedVideo._id)}
          >
            <VideoCardV2
              video={selectedVideo}
              titleStyles={{ fontSize: "20px" }}
              shouldShowStripDescription={true}
            />
          </div>
        )}

        {videos && videos.length > 0 && (
          <Row xs={1} sm={1} md={1} lg={2} className="g-0 mb-5 mt-3 mt-md-0">
            {videos.map((video) => {
              const hasComingSoonTag = video.tagsDetails?.some(
                (tag) => tag.name === "coming soon"
              );

              return (
                <Col key={video._id} className="p-1 d-grid justify-content-center">
                  <div
                    onClick={() => {
                      if (!hasComingSoonTag) redirectToVideo(video._id);
                    }}
                    style={
                      hasComingSoonTag
                        ? { opacity: 0.7, cursor: "default", maxWidth: "100%" }
                        : { cursor: "pointer", maxWidth: "100%" }
                    }
                  >
                    <VideoCardV2
                      video={video}
                      titleStyles={{ fontSize: "12px" }}
                      tagStyles={{ padding: "5px" }}
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
        )}

        {products && products?.length > 0 && (
          <div>
            <Row xs={1} md={2} className="g-0">
              {products.map((product) => (
                <Col
                  key={product.handle}
                  className="p-2 d-flex justify-content-center"
                >
                  <div onClick={() => redirectToProduct(product)}>
                    <VideoCardV2
                      product={product}
                      customStyles={{ minWidth: "200px" }}
                      titleStyles={{ fontSize: "14px" }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewMoreModal;
